export default "__VITE_ASSET__931b4b47__"